if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        setTimeout(() => {
          this.initZoom();
        }, 100);

        setTimeout(() => {
          this.initNavigation();
        }, 100);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.style.display = 'none';
        });

        activeMedia.style.display = 'block';
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
      initZoom() {
        const activeMedia = this.querySelector('img.active');
        console.log('Zoom image found:', activeMedia);

        if (!activeMedia) return;
        activeMedia.style.cursor = 'grab';

        if (activeMedia.dataset.zoomInitialized) return;
        activeMedia.dataset.zoomInitialized = 'true';

        let scale = parseFloat(activeMedia.dataset.zoomScale || 1);

        let isDragging = false;
        let startX = 0;
        let startY = 0;

        let translateX = parseFloat(activeMedia.dataset.translateX || 0);
        let translateY = parseFloat(activeMedia.dataset.translateY || 0);

        activeMedia.style.transition = 'transform 0.15s ease';
        const updateTransform = () => {
                  activeMedia.style.transform =
                    `translate(${translateX}px, ${translateY}px) scale(${scale})`;
                };
        activeMedia.addEventListener(
          'wheel',
          (e) => {
            e.preventDefault();

            const rect = activeMedia.getBoundingClientRect();

            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;

            activeMedia.style.transformOrigin = `${x}% ${y}%`;

            if (e.deltaY < 0) {
              scale += 0.15;
            } else {
              scale -= 0.15;
            }

            scale = Math.max(1, Math.min(scale, 5));
            
            if (scale === 1) {
              translateX = 0;
              translateY = 0;

              activeMedia.dataset.translateX = 0;
              activeMedia.dataset.translateY = 0;
            }

            activeMedia.dataset.zoomScale = scale;
            updateTransform();
          },
          { passive: false }
        );
        activeMedia.addEventListener('mousedown', (e) => {
          if (scale <= 1) return;
          this.isDraggingImage = true;
          isDragging = true;

          startX = e.clientX - translateX;
          startY = e.clientY - translateY;

          activeMedia.style.cursor = 'grabbing';

          e.preventDefault();
          activeMedia.style.transition = 'none';
        });

        window.addEventListener('mousemove', (e) => {
          if (!isDragging) return;

          translateX = e.clientX - startX;
          translateY = e.clientY - startY;

          activeMedia.dataset.translateX = translateX;
          activeMedia.dataset.translateY = translateY;

          updateTransform();
        });

        window.addEventListener('mouseup', () => {
          isDragging = false;

          setTimeout(() => {
            this.isDraggingImage = false;
          }, 50);

          activeMedia.style.transition = 'transform 0.15s ease';
          activeMedia.style.cursor = scale > 1 ? 'grab' : 'default';
        });
      }
      initNavigation() {
        if (this.navigationInitialized) return;
        this.navigationInitialized = true;
        const prevBtn = this.querySelector('.mc-modal-prev');
        const nextBtn = this.querySelector('.mc-modal-next');
        const closeBtn = this.querySelector('.mc-modal-close');

        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          this.changeMedia(-1);
        }, true);

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          this.changeMedia(1);
        }, true);

        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            this.hide();
          });
        }
      }

        changeMedia(direction) {
        console.log('Current active:', this.querySelector('.active'));
        const mediaItems = [
        ...this.querySelectorAll(
          '.product-media-modal__content img[data-media-id]'
        )
      ];
        console.log('Media count:', mediaItems.length);
        console.log(mediaItems);

        const currentIndex = mediaItems.findIndex(
          item => item.style.display !== 'none'
        );

        let nextIndex = currentIndex + direction;

        if (nextIndex < 0) {
          nextIndex = mediaItems.length - 1;
        }

        if (nextIndex >= mediaItems.length) {
          nextIndex = 0;
        }

        mediaItems.forEach(item => {
        item.style.display = 'none';
        item.classList.remove('active');
      });

      mediaItems[nextIndex].style.display = 'block';
      mediaItems[nextIndex].classList.add('active');

      console.log('New active:', mediaItems[nextIndex]);

      this.initZoom();
      }
    }
  );
}
